<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" />

  <div class="row">
    <div textInput [control]="datiGeneraliForm.controls['pubblicoMinistero']" class="col-sm-3"
      [labelInput]="'Pubblico Ministero (P.M.)'" [labelClass]="'label-alta'"  formControlName="pubblicoMinistero"
      [(ngModel)]="request.fascicolo.pubblicoMinistero"></div>

    <div textInput [control]="datiGeneraliForm.controls['provenienzaFascicolo']" class="col-sm-3"
      [labelInput]="'Provenienza fascicolo'" [labelClass]="'label-alta'"  formControlName="provenienzaFascicolo"
      [(ngModel)]="request.fascicolo.provenienzaFascicolo"></div>

    <div textInput [control]="datiGeneraliForm.controls['numeroRegistroGeneraleAffariPenali']" class="col-sm-3"
      [labelInput]="'N. Registro Generale Affari Penali'"  [labelClass]="'label-alta'"  formControlName="numeroRegistroGeneraleAffariPenali"
      [(ngModel)]="request.fascicolo.numeroRegistroGeneraleAffariPenali"></div>

    <div checkBoxRadio class="col-sm-3" [labelInput]="'Richiesta oblazione'" [labelClass]="'label-alta'" idInput="richiesta_oblazione"
      formControlName="richiestaOblazione" [objectReference]="request.fascicolo.richiestaOblazione"
      (onReturn)="request.fascicolo.richiestaOblazione = $event"></div>

  </div>

  <!-- <div class="row">
    <fieldset class="form-group">
      <legend>Prove</legend>
      <div checkBoxRadio class="col-sm-3" [labelInput]="'Sufficienza delle prove'" idInput="suff_prove"
        formControlName="sufficienzaProve" (change)="request.fascicolo.prove = null"
        [objectReference]="request.fascicolo.sufficienzaProve" (onReturn)="request.fascicolo.sufficienzaProve = $event">
      </div>

      <div textAreaInput class="col-sm-9" [submitPending]="!request.fascicolo.sufficienzaProve" [labelInput]="'Prove'"
        formControlName="prove" [(ngModel)]="request.fascicolo.prove"></div>

    </fieldset>
  </div> -->
  <div class="row">
    <fieldset class="form-group">
      <legend>Misure cautelari</legend>
      <div checkBoxRadio class="col-sm-3" [labelInput]="'Misure cautelari'" idInput="misure_cautelari"
        formControlName="misureCautelari" (change)="request.fascicolo.misuraAdottata = null"
        [objectReference]="request.fascicolo.misureCautelari" (onReturn)="request.fascicolo.misureCautelari = $event">
      </div>

      <div textAreaInput class="col-sm-9" [submitPending]="!request.fascicolo.misureCautelari"
        [labelInput]="'Misura adottata'" formControlName="misuraAdottata"
        [(ngModel)]="request.fascicolo.misuraAdottata"></div>

    </fieldset>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
      [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12"><em>* Campi obbligatori</em></p>
  </div>
  <!-- <div *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi"
    class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)"></p>
    </div>
  </div> -->

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm.emit()">Reset</button>
    </p>
    <!--
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
      [labelButton]="'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
                        (!request.fascicolo.flagFondoRischi && !inserimento && !wizard ? !request.fascicolo.dataVariazioneFondoRischi : false) ||
                        !datiGeneraliForm.valid"></p> -->
    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'"
      [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
